export const EARN_REFERENCE_PREFIX = 'EARN_REF'
export const MERCHANT_RETAINED_EARNINGS_PERCENTAGE = 100
